/**
 * A list opened from a share link, viewable without an account.
 * The header's Sign in button is the only sign-in prompt; the list name and creator sit under the map.
 */
import { HeadlinerMap } from "../components/headliner-map";

export default function SharedListPage({ token }: { token: string }) {
  return (
    <div className="flex flex-col gap-10 pb-24">
      <HeadlinerMap source={{ token }} />
    </div>
  );
}
